spineManager = {};
spineManager.index = 0;
spineManager.activeSpineObjects = [];
spineManager.spineData = {};
spineManager.cachedSpineObjects = {};
spineManager.STARTING_CACHE_QTY = 1;

var invoker = function (obj, funcName) {
  return function (param1, param2) {
    obj[funcName](param1, param2);
  };
};

spineManager.update = function (delta) {
  for (var i = 0; i < spineManager.activeSpineObjects.length; i++) {
    if (
      spineManager.activeSpineObjects[i].visible &&
      spineManager.activeSpineObjects[i].playing
    ) {
      spineManager.activeSpineObjects[i].spineObject.update(delta / 1000);
    }
  }
};

spineManager.getSpineFromCache = function (name, animation) {
  if (spineManager.spineData[name] === undefined) {
    console.error(
      "Spine object " + name + " does not exist in the spine cache"
    );
  } else {
    // Check if a spine object is available in the cache
    if (spineManager.cachedSpineObjects[name].length > 0) {
      // Spine object available in the cache, so return this
      return spineManager.cachedSpineObjects[name].pop();
    } else {
      // Spine object not in the cache so create new one
      return spineManager.createSpineObject(name, animation);
    }
  }
};

spineManager.createSpineObject = function (name, animation) {
  var spineObject = new PIXI.spine.Spine(spineManager.spineData[name]);
  spineObject.spineManagerName = name;
  if (animation === undefined) {
    animation = spineObject.spineData.animations[0].name;
  }

  spineObject.state.setAnimation(0, animation, false);
  spineObject.update(0);
  return spineObject;
};

spineManager.create = function (json) {
  return new PIXI.Container();
};

spineManager.getAnimationTime = function (spineObjectType, animationName) {
  var animations = spineManager.spineData[spineObjectType].animations;
  for (var i = 0; i < animations.length; i++) {
    if (animations[i].name === animationName)
      return animations[i].duration * 1000;
  }

  console.warn("Animation " + animationName + " not found in spine object");
  return 0;
};

spineManager.initialise = function (json, container, resources) {
  if (json.name) {
    // Create spine object from named resource in config.preloadGraphics
    if (spineManager.spineData[json.name] == undefined) {
      console.error("No spine data found for " + json.name);
    } else {
      container.spineObject = spineManager.getSpineFromCache(
        json.name,
        json.defaultAnimation
      );
    }
  } else if (json.fileName) {
    // File was loaded via an autogenerated file name
    container.spineObject = new PIXI.spine.Spine(
      spineManager.spineData[
        spineManager.getHash(ReflexLoader.rootResDir + json.fileName)
      ]
    );
    container.spineObject.state.setAnimation(0, json.defaultAnimation, false);
    container.spineObject.update(0);
  } else {
    // No spine object defined
    console.error(
      "PIXI object must defined a named preloaded graphic, or a filename to load"
    );
    return;
  }

  container.addChild(container.spineObject);
  container.spineObject.autoUpdate = false;
  container.playing = false;

  if (json.defaultAnimation === undefined) {
    json.defaultAnimation = container.spineObject.spineData.animations[0].name;
  }

  container.spineObject.state.setAnimation(
    0,
    container.Props.defaultAnimation,
    false
  );
  container.spineObject.update(0);

  spineManager.activeSpineObjects.push(container);

  if (spineManager.activeSpineObjects.length === 1) {
    Reflex.addToUpdate(spineManager.update);
  }

  container.stop = function () {
    this.playing = false;
    container.spineObject.update(0);
  };

  // Hijack the root container tint, and tint the spine object instead
  Object.defineProperty(container, "tint", {
    get: function () {
      return container.spineObject.tint;
    },
    set: function (value) {
      container.spineObject.tint = value;
      container.spineObject.update(0);
    },
  });

  container.isPlaying = function () {
    return container.playing;
  };

  container.setSkin = function (name) {
    // This is a work around for PIXI not showing correct skin for models with multiple skins
    this.spineObject.skeleton.setSkin(null);
    this.spineObject.skeleton.setSkinByName(name);
  };

  container.getAnimationTime = function (spineObjectType, animationName) {
    return spineManager.getAnimationTime(spineObjectType, animationName);
  };

  container.mixAnims = function (fromAnim, toAnim, mixTime) {
    this.spineObject.stateData.setMix(fromAnim, toAnim, mixTime);
  };

  container.play = function (
    animation,
    loop,
    trackTime,
    endedCallback,
    eventCallback,
    startCallback
  ) {
    if (loop === undefined) {
      loop = false;
    }

    if (trackTime === undefined) {
      trackTime = 0;
    }

    container.loop = loop;
    container.endedCallback = endedCallback;
    this.spineObject.state.setAnimation(0, animation, loop);
    this.spineObject.state.tracks[0].trackTime = trackTime;
    this.spineObject.update(0);
    this.playing = true;

    // Start callback
    if (startCallback !== undefined) {
      this.spineObject.state.addListener({ complete: startCallback });
    }

    // Event callback
    if (eventCallback !== undefined) {
      //this.spineObject.state.addListener({ complete: eventCallback } );
      this.spineObject.state.addListener({
        event: function (i, event) {
          eventCallback(i, event);
        },
      });
    }

    // End callback (called each time for loops)
    container.onEndedCallback = function (a, b, c) {
      if (!this.loop) {
        this.playing = false;
        this.spineObject.state.clearListeners();

        if (this.endedCallback) {
          this.endedCallback(this);
        }
      }
    };
    // // Clear any listeners
    // this.spineObject.state.clearListeners();
    this.spineObject.state.addListener({
      complete: invoker(container, "onEndedCallback"),
    });
  };
};

spineManager.onFileLoaded = function (
  percent,
  loadGroup,
  resourceLoaded,
  resources
) {
  if (
    resourceLoaded.extension === "json" &&
    resourceLoaded.name !== undefined
  ) {
    // Look for spine data
    if (resources[resourceLoaded.name] !== undefined) {
      var spineData = resources[resourceLoaded.name].spineData;
      if (spineData !== undefined) {
        // Found spine data so store for creating spine objects later on
        if (spineManager.spineData[resourceLoaded.name] === undefined) {
          spineManager.spineData[resourceLoaded.name] = spineData;

          spineManager.cachedSpineObjects[resourceLoaded.name] = [];
          for (var i = 0; i < spineManager.STARTING_CACHE_QTY; i++) {
            // Create cache of spine objects
            var spineObject = spineManager.createSpineObject(
              resourceLoaded.name
            );
            spineManager.cachedSpineObjects[resourceLoaded.name].push(
              spineObject
            );
            var defaultAnimation = spineData.animations[0].name;
            spineObject.state.setAnimation(0, defaultAnimation, false);
            spineObject.update(0);
          }
        }
      }
    }
  }
};

spineManager.getFilesRequired = function (json) {
  // Is this a spine name (loading in config.preloadGraphics) or filename (autogenerate name from filename)
  if (json.name) {
    // Files are loaded in preloader, so we dont need to load anything
    return [];
  } else {
    // Spine file needs to be loaded
    var spineHash = spineManager.getHash(Loader.rootResDir + json.fileName);
    return [{ name: spineHash, file: Loader.rootResDir + json.fileName }];
  }
};

spineManager.destroy = function (container) {
  var index = spineManager.activeSpineObjects.indexOf(container);
  if (index === -1) {
    // We cant destroy an object that is not active
    console.log(
      "Cannot delete spine object " +
        container.Props.FQN +
        "(" +
        container.spine.spineManagerName +
        ") as it is not active"
    );
    return;
  }

  container.removeChild(container.spineObject);
  spineManager.activeSpineObjects.splice(index, 1);

  // Return the spine object to the cache and delete reference
  spineManager.cachedSpineObjects[container.spineObject.spineManagerName].push(
    container.spineObject
  );
  container.spineObject = undefined;

  if (spineManager.activeSpineObjects.length === 0) {
    Reflex.removeFromUpdate(spineManager.update);
  }
};

spineManager.getHash = function (name) {
  var hash = "",
    i,
    chr;
  if (name.length === 0) return hash;
  for (i = 0; i < name.length; i++) {
    chr = name.charCodeAt(i);
    if (
      (chr >= 48 && chr <= 57) ||
      (chr >= 65 && chr <= 90) ||
      (chr >= 97 && chr <= 122)
    ) {
      hash += name.charAt(i);
    }
  }
  return hash;
};

resourceManager.registerLoadProgressCallback(spineManager.onFileLoaded);
resourceManager.registerObjectType(
  "spine",
  spineManager.create,
  spineManager.initialise,
  spineManager.getFilesRequired,
  spineManager.destroy
);
